// extracted by mini-css-extract-plugin
export default {"body":"InviteDialog-module__body--lnUEI"};